import type { IBaseAttributes, TConstraints } from '@feathr/rachis';
import { Collection, Model } from '@feathr/rachis';

export enum EGoalTypeV1 {
  ad_click = 'ad_click',
  custom = 'custom',
}

export enum EGoalType {
  page_view = 'page_view',
  group_entry = 'group_entry',
  conversion_pixel = 'conversion_pixel',
  donation_form_submission = 'donation',
  form_submission = 'form_submission',
}

export interface IGoal extends IBaseAttributes {
  conv_type: EGoalType | EGoalTypeV1;
  conv_value: number;
  date_last_modified: string;
  name: string;
  /**
   * Determines whether conversions should count more than
   * once per person.
   */
  multi_conversions: boolean;
  parent: string;
  segment?: string;
  kind?: 'campaign' | 'flight';
}

export const MAX_GOALS = 5;

export class Goal extends Model<IGoal> {
  public readonly className = 'Goal';

  public get constraints(): TConstraints<IGoal> {
    return {
      conv_value: {
        presence: {
          allowEmpty: true,
        },
        numericality: {
          greaterThan: -1,
          notValid: '^The value must be 0 or greater',
        },
      },
      segment: {
        presence: {
          allowEmpty: false,
          message: '^You must provide a valid group or remove the goal',
        },
      },
      name: {
        presence: {
          allowEmpty: false,
        },
      },
      conv_type: {
        presence: {
          allowEmpty: false,
        },
        inclusion: {
          within: [...Object.values(EGoalTypeV1), ...Object.values(EGoalType)],
          message: '^The goal is not of a valid type',
        },
      },
    };
  }

  public override getDefaults(): Partial<IGoal> {
    return {
      conv_value: 5,
    };
  }
}

export class Goals extends Collection<Goal> {
  public getClassName(): string {
    return 'goals';
  }

  public getModel(attributes: Partial<IGoal>): Goal {
    return new Goal(attributes);
  }
}
